import { useEffect } from 'react'
import { useHistory } from "react-router-dom";

export default function ScrollToTopOnMount() {
    let history = useHistory();
    
    useEffect(() => {
      if (history.action === 'PUSH')
        if (history.location.hash !== '') {
          const id = history.location.hash.replace('#', '')
          const elm = document.getElementById(id)
          elm && elm.scrollIntoView();
        }
        else
          window.scrollTo(0, 0);
    }, [history.action, history.location]);
  
    return null;
}